import React, { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import "../../../../../Styles/SignatureModal.scss";
import ApeendInputsComponent from "../../../../ApeendInputsComponent/ApeendInputsComponent";
import { useParams } from "react-router";
import { studyOnboardingService } from "../../../../../Services/studyServices/studySubjectsServices";
import { randomizerServices } from "../../../../../Services/IWRS/randomizerServices";

const UpdateJsonData = ({
  SHOW,
  HIDE,
  Title,
  Label1,
  Label2,
  Label3,
  Label4,
  Label5,
  PlaceHolder,
  PlaceHolder3,
  PlaceHolder4,
  PlaceHolder5,
  Value1,
  Value2,
  Value3,
  Value4,
  Value5,
  type1,
  type2,
  type3,
  type4,
  type5,
  inputField3,
  inputField4,
  inputField5,
  OnChange1,
  OnChange2,
  OnChange3,
  OnChange4,
  OnChange5,
  DropDown1,
  DropDown2,
  DropDown3,
  DropDown4,
  DropdownLabel1,
  DropdownLabel2,
  DropdownLabel3,
  DropdownLabel4,
  DropValue3,
  DropValue4,
  DropdownPlaceHolder1,
  DropdownPlaceHolder2,
  DropdownPlaceHolder3,
  DropdownPlaceHolder4,
  DropdownValue1,
  DropdownValue2,
  DropdownOnChange1,
  DropdownOnChange2,
  DropdownOnChange3,
  DropdownOnChange4,
  ageGroupList,
  genderList,
  HistoryData,
  onChangeInput,
  UpdateHistoryOnChange,
  SubmitTitle,
  SubmitForm,
  studyDynamicColumnData,

  formValues,
  handleChange,
  removeFormFields,
  addFormFields,
  UpdateRow,
  AddRowLabel,
  UpdateRowLabel,

  Radio,
  CommentValue,
  CommentOnChange,
  UpdateHistory,
  HistoryValue,
  HistoryOnChangeInput,
  Class,
  siteList,
  SiteDropDown,
  SiteDropdownLabel,
  SiteDropdownOnChange,
  SiteDropdownPlaceHolder,
  SiteDropdownValue,

  RandomDropDown,
  RandomDropdownLabel,
  RandomDropdownOnChange,
  RandomDropdownPlaceHolder,
  RandomDropdownValue,

  SubjectGender,
  SubjectGenderDropdownChange,
  subjectGenderValue,
  StudyMode
}) => {
  const { studyId } = useParams();
  const [randomizerList, setRandomizerList] = useState([]);
  const [factorData, setFactorData] = useState([])

  const studyPermissionData = JSON.parse(
    localStorage.getItem("studyPermissionData")
  );

  let permissionRandomizer = StudyMode === "Live Mode" ? (studyPermissionData?.randomizarForLive || []) : StudyMode === "QC Mode" ? (studyPermissionData?.randomizarForQC || []) : []

  const getRandomizerMetadataData = async () => {
    let data = await randomizerServices.getRandomizerMetadataData(studyId, StudyMode)
    if (StudyMode === "DBP MODE") {
      setRandomizerList(data?.data || [])
    } else {
      let result = (data?.data || [])?.filter((item) => permissionRandomizer?.includes(item._id));
      setRandomizerList(result)
    }
  }

  const showLabel = (label, htmlFor) => (
    <Form.Label htmlFor={htmlFor} className="mb-1 fw-bold d-flex">
      {label}
    </Form.Label>
  );
  let [removeSubjectColumn, setRemoveSubjectColumn] = useState([])
  const getAllSubjectPreDefineColumnOption = async () => {
    let data = await studyOnboardingService.getAllSubjectPreDefineColumnOption(studyId)
    setRemoveSubjectColumn(data?.data?.map(item => item.option) || [])
  }

  const [singleSite, setSingleSite] = useState("");
  const getSingleStudySite = async (siteUniqueId) => {
    let data = await studyOnboardingService.getSingleStudySite(studyId, siteUniqueId)
    setSingleSite(data?.data || [])
  }

  const getStudySubjectColumnForFactor = async () => {
    let data = await studyOnboardingService.getStudySubjectColumnForFactor(studyId)
    setFactorData(data?.data || [])
  }

  useEffect(() => {
    getRandomizerMetadataData()
    getStudySubjectColumnForFactor()
    getAllSubjectPreDefineColumnOption();
  }, [studyId]);

  return (
    <>
      <Offcanvas show={SHOW} onHide={HIDE} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="text-center">{Title}</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="w-100">
            {Radio && (
              <div className="signInTerms">
                <span className="mb-3">
                  You are required to provide a signature for this activity in
                  order to fully complete it. This records that you are signing
                  off theat you have taken, and completed this online review
                  activity. This will resilt in the completion record being
                  recorded in your review history.
                </span>
              </div>
            )}

            {OnChange1 && (
              <>
                {showLabel(Label1, "one")}

                <Form.Control
                  type={type1}
                  className="mb-2"
                  id="one"
                  value={Value1}
                  onChange={OnChange1}
                  required
                />
              </>
            )}

            {OnChange2 && (
              <>
                {showLabel(Label2, "two")}

                <input
                  type={type2}
                  className="form-control inputboxborder mb-3"
                  id="two"
                  value={Value2}
                  onChange={OnChange2}
                  required
                />
              </>
            )}

            {Radio && (
              <>
                {showLabel("Comment", "comment")}

                <textarea
                  className="form-control inputboxborder mb-3"
                  cols="30"
                  rows="3"
                  id="comment"
                  PlaceHolder="Enter Comments"
                  value={CommentValue}
                  onChange={CommentOnChange}
                />
              </>
            )}

            {inputField3 && (
              <>
                {showLabel(Label3, "three")}

                <input
                  type={type3}
                  className="form-control inputboxborder mb-3"
                  id="three"
                  value={Value3}
                  onChange={OnChange3}
                  placeholder={PlaceHolder3}
                  required
                />
              </>
            )}

            {SiteDropDown && (
              <>
                {showLabel(SiteDropdownLabel)}

                <Form.Select
                  className="mb-2"
                  id="autoSizingSelect"
                  onChange={(e) => { SiteDropdownOnChange(e.target.value); getSingleStudySite(e.target.value) }}
                >
                  <option>{SiteDropdownPlaceHolder}</option>
                  {siteList?.map((item, key) => (
                    <option
                      selected={
                        SiteDropdownValue === item.gender ? true : false
                      }
                      key={key}
                      value={item.studyUniqueId}
                      id={item.studyUniqueId}
                    >
                      {item.siteIdLabel}
                    </option>
                  ))}
                </Form.Select>
              </>
            )}

            {RandomDropDown && singleSite?.subjectSettings === "iwrs" && (
              <>
                {showLabel(RandomDropdownLabel)}

                <Form.Select
                  className="mb-2"
                  id="autoSizingSelect"
                  onChange={(e) => { RandomDropdownOnChange(e.target.value) }}
                >
                  <option>{RandomDropdownPlaceHolder}</option>
                  {randomizerList?.map((item, key) => (
                    (item?.edc === "yes" && !item?.totalBlock) &&
                    <option
                      selected={
                        RandomDropdownValue === item._id ? true : false
                      }
                      key={key}
                      value={item._id}
                    >
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </>
            )}

            {inputField4 && singleSite?.subjectSettings === "manual" && (
              <>
                {showLabel(Label4, "four")}

                <Form.Control
                  type={type4}
                  className="mb-2"
                  id="four"
                  value={Value4}
                  onChange={OnChange4}
                  placeholder={PlaceHolder4}
                  required
                />
              </>
            )}

            {SubjectGender && removeSubjectColumn?.length > 0 && (
              <>
                {showLabel("Subject Gender")}

                <Form.Select
                  className="mb-2"
                  id="autoSizingSelect"
                  onChange={SubjectGenderDropdownChange}
                >
                  <option>{"Select Subject Gender"}</option>
                  {removeSubjectColumn?.map((item, index) => (
                    <option key={index} selected={subjectGenderValue === item?.toLowerCase()} value={item?.toLowerCase()}>{item}</option>
                  ))}
                </Form.Select>
              </>
            )}

            {DropDown1 && (
              <>
                {showLabel(DropdownLabel1)}

                <Form.Select
                  className="mb-2"
                  id="autoSizingSelect"
                  onChange={DropdownOnChange1}
                >
                  <option>{DropdownPlaceHolder1}</option>
                  {genderList?.map((item, key) => (
                    <option
                      selected={DropdownValue1 === item.gender ? true : false}
                      key={key}
                      value={item.gender}
                    >
                      {item.gender}
                    </option>
                  ))}
                </Form.Select>
              </>
            )}

            {DropDown2 && (
              <>
                {showLabel(DropdownLabel2)}
                <Form.Select
                  className="mb-2"
                  id="autoSizingSelect"
                  onChange={DropdownOnChange2}
                >
                  <option>{DropdownPlaceHolder2}</option>
                  {ageGroupList?.map((item, key) => (
                    <option
                      selected={DropdownValue2 === item.ageGroup ? true : false}
                      key={key}
                      value={item.ageGroup}
                    >
                      {`${item.ageGroup} Year`}
                    </option>
                  ))}
                </Form.Select>
              </>
            )}

            {studyDynamicColumnData
              ? studyDynamicColumnData?.map(
                (
                  {
                    name,
                    types,
                    valueData,
                    options,
                    history,
                    formUniqueId,
                    fieldUniqueId,
                  },
                  i
                ) =>
                  formUniqueId && fieldUniqueId ? (
                    ""
                  ) :
                      <>
                        <div key={i}>
                          {AddRowLabel && showLabel(name)}

                          {UpdateRowLabel && showLabel(name)}
                          {types === "dropdown" ?
                            <Form.Select className="mb-2 w-100" name="valueData" onChange={(e) => onChangeInput(e, i)}>
                              <option selected value={""}>Select</option>
                              {options?.map((data, i) => (
                                <option selected={valueData === data?.option} name="valueData" value={data?.option} key={i}>{data?.option}</option>
                              ))}
                            </Form.Select>
                            :
                            <Form.Control
                              key={i}
                              type={types}
                              className="mb-2 w-100"
                              name="valueData"
                              value={valueData}
                              onChange={(e) => onChangeInput(e, i)}
                              placeholder={PlaceHolder}
                              required
                            />
                          }
                        </div>
                        {HistoryData && (
                          <div key={i}>
                            {AddRowLabel && showLabel("Comment")}

                            {UpdateRowLabel && showLabel("Comment")}

                            <Form.Control
                              key={i}
                              as={"textarea"}
                              className="mb-2 w-100"
                              name="history"
                              value={history}
                              onChange={(e) => UpdateHistoryOnChange(e, i)}
                              placeholder={"Enter Comment"}
                              required
                            />
                          </div>
                        )}
                      </>
              )
              : ""}

            {!UpdateRow && (
              <ApeendInputsComponent
                formValues={formValues}
                handleChange={handleChange}
                removeFormFields={removeFormFields}
                addFormFields={addFormFields}
              />
            )}

            {DropDown3 && (
              <>
                {showLabel(DropdownLabel3)}

                <Form.Select
                  className="mb-2"
                  id="autoSizingSelect"
                  onChange={DropdownOnChange3}
                >
                  <option>{DropdownPlaceHolder3}</option>
                  <option
                    selected={DropValue3 === "yes" ? true : false}
                    value={"yes"}
                  >
                    Yes
                  </option>
                  <option
                    selected={DropValue3 === "no" ? true : false}
                    value={"no"}
                  >
                    No
                  </option>
                </Form.Select>
              </>
            )}

            {DropDown4 && (
              <>
                {showLabel(DropdownLabel4)}

                <Form.Select
                  className="mb-2"
                  id="autoSizingSelect"
                  onChange={DropdownOnChange4}
                >
                  <option>{DropdownPlaceHolder4}</option>
                  <option
                    selected={DropValue4 === "afterFirstVisits" ? true : false}
                    value={"afterFirstVisits"}
                  >
                    After First Visits
                  </option>
                  <option
                    selected={DropValue4 === "anyTime" ? true : false}
                    value={"anyTime"}
                  >
                    Any Time
                  </option>
                </Form.Select>
              </>
            )}

            {UpdateHistory && (
              <>
                {showLabel("History")}

                <Form.Control
                  className="mb-2 w-100"
                  name="valueData"
                  value={HistoryValue}
                  onChange={(e) => HistoryOnChangeInput(e)}
                  placeholder={"Update History"}
                  required
                />
              </>
            )}

            {inputField5 && (
              <>
                {showLabel(Label5, "five")}

                <Form.Control
                  type={type5}
                  className="mb-2"
                  id="five"
                  value={Value5}
                  onChange={OnChange5}
                  placeholder={PlaceHolder5}
                  required
                />
              </>
            )}
          </div>
          <div className="text-end">
            <div onClick={SubmitForm}>
              <button onClick={HIDE} className="submitbutton">
                {SubmitTitle}
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default UpdateJsonData;
